import { render, staticRenderFns } from "./interpretertSatistics.vue?vue&type=template&id=25eb3f22&scoped=true&"
import script from "./interpretertSatistics.vue?vue&type=script&lang=js&"
export * from "./interpretertSatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb3f22",
  null
  
)

export default component.exports